// extracted by mini-css-extract-plugin
module.exports =  {"stepper":"stepper-OL8zv","header":"header-fEtxa","content":"content-A6qIn","button":"button-fisbt","icon":"icon-zdvuT","value":"value-Z6LnU"};